<div class="rsvp-page">
  <div class="rsvp-card">
    <div class="rsvp-brand">Bistec Apex</div>

    <!-- Loading -->
    <div class="rsvp-body" *ngIf="loading">
      <i class="pi pi-spin pi-spinner rsvp-spinner"></i>
      <p>Loading your invitation…</p>
    </div>

    <!-- Invalid / expired -->
    <div class="rsvp-body" *ngIf="!loading && notFound">
      <i class="pi pi-times-circle rsvp-icon rsvp-icon--error"></i>
      <h1>Invitation not found</h1>
      <p class="rsvp-muted">This invitation link is invalid or has expired. Please contact your organizer.</p>
    </div>

    <!-- Invite -->
    <div class="rsvp-body" *ngIf="!loading && !notFound && invite">
      <ng-container *ngIf="!confirmed">
        <h1>You're invited</h1>
        <p class="rsvp-muted">Hi {{ invite.employeeName }}, please confirm your participation.</p>
      </ng-container>
      <ng-container *ngIf="confirmed">
        <i class="pi pi-check-circle rsvp-icon rsvp-icon--success"></i>
        <h1>Participation confirmed</h1>
        <p class="rsvp-muted">Thanks, {{ invite.employeeName }} — we've recorded your participation. See you there!</p>
      </ng-container>

      <div class="rsvp-details">
        <div class="rsvp-row"><span>Event</span><strong>{{ invite.eventName }}</strong></div>
        <div class="rsvp-row"><span>Project</span><strong>{{ invite.projectName }}</strong></div>
        <div class="rsvp-row"><span>Organized by</span><strong>{{ invite.pmName }}</strong></div>
        <div class="rsvp-row"><span>Date</span><strong>{{ invite.plannedDate | date:'fullDate' }}</strong></div>
        <div class="rsvp-row" *ngIf="invite.startTime"><span>Time</span><strong>{{ invite.startTime }}</strong></div>
        <div class="rsvp-row" *ngIf="invite.location"><span>Venue</span><strong>{{ invite.location }}</strong></div>
        <div class="rsvp-row" *ngIf="invite.remarks"><span>Details</span><strong>{{ invite.remarks }}</strong></div>
      </div>

      <p-button *ngIf="!confirmed" label="Confirm Participation" icon="pi pi-check"
                [loading]="confirming" (onClick)="confirm()" severity="primary"
                styleClass="rsvp-confirm-btn" />
    </div>
  </div>
</div>
